import { createElement } from "../utils";
import text from '../constants.js';
import renderControl from './renderControl.js';

export default function renderHeader (componentElement, props, data, obj) {
    if(obj.mode != 1) componentElement.classList.add('x-component-header');

    const label = createElement('div', {
        className: obj.mode == 1 ? 'x-label x-preview' : 'x-label x-component-header',
        innerText: data.label
    });
    
    if(obj.mode == 1){
        label.title = text.HEADER_TITLE;
        label.contentEditable = true
    }   

    const help_text = obj.mode == 1 ? (data.help || text.HELP) : (data.help ?? text.HELP);
    const description = createElement('div', {
        className: obj.mode == 1 ? 'x-help x-preview' : 'x-help x-component-header',
        innerText: help_text
    });

    if(obj.mode == 1) description.contentEditable = true

    componentElement.appendChild(label);
    componentElement.appendChild(description);

    if(obj.mode == 1){
        const footer = createElement('div', {
            className: 'x-footer',
        });     
        footer.appendChild(renderControl(componentElement, data, ['required']));                   
        componentElement.appendChild(footer);            
    }

    obj.content.appendChild(componentElement);
}